export const BAREBONES_THEME = "barebones"

export const isBarebonesTheme = (theme: string | null | undefined) =>
  theme === BAREBONES_THEME
